import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import './DataTable.scss'

const DataTableHeaderCol = ({ className, width, children, isOrdinable, orderDescending, orderCallback }) => {
  const compClassName = classnames(className,
    {
      datatable__col: !width,
      [`datatable__col-${width}`]: width
    }
  )
  return (
    <div className={compClassName}><h4>{children}</h4>
    </div>
  )
}

DataTableHeaderCol.defaultProps = {
  width: undefined
}

DataTableHeaderCol.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  children: PropTypes.node
}

export default DataTableHeaderCol
